export const compareTime = (
  currentTime: number | string | Date,
  examStartTime: number | string | Date
) => {
  const timeLeft = (+examStartTime - +currentTime) / 1000; // in seconds
  return timeLeft;
};
